// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2B0Zn","notes":"Notes_notes__g1d3o","note":"Notes_note__32BD2","markdown":"Notes_markdown__3NLLY"};